import React, { useState } from "react";
import api, { apiErr } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Loader2, Camera, X } from "lucide-react";
import { useSucursalesActivas } from "../lib/useSucursales";
import { toast } from "sonner";

const input = "w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100";
const CATEGORIAS = ["Combustible", "Mantenimiento", "Alquiler", "Servicios", "Sueldos varios", "Insumos", "Otros"];

export function GastoModal({ open, onClose, isAdmin, onSaved }) {
  const sucs = useSucursalesActivas().map((s) => s.code);
  const [form, setForm] = useState({ descripcion: "", categoria: "Combustible", monto: "", sucursal: "ASU" });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const pickFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      let comprobante_path = null;
      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/uploads/comprobante", fd, { headers: { "Content-Type": "multipart/form-data" } });
        comprobante_path = data.path;
      }
      await api.post("/gastos", {
        descripcion: form.descripcion, categoria: form.categoria,
        monto: Number(form.monto), sucursal: isAdmin ? form.sucursal : undefined, comprobante_path,
      });
      toast.success("Gasto registrado");
      setForm({ descripcion: "", categoria: "Combustible", monto: "", sucursal: "ASU" });
      setFile(null); setPreview(null);
      onSaved && onSaved(); onClose();
    } catch (e2) { toast.error(apiErr(e2)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle className="font-display">Registrar gasto</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <select className={input} value={form.categoria} onChange={(e) => setForm({ ...form, categoria: e.target.value })} data-testid="gasto-categoria">
            {CATEGORIAS.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <input className={input} placeholder="Descripción (ej. combustible moto 3)" value={form.descripcion} onChange={(e) => setForm({ ...form, descripcion: e.target.value })} required data-testid="gasto-descripcion" />
          <input className={input} type="number" min="1" placeholder="Monto (Gs.)" value={form.monto} onChange={(e) => setForm({ ...form, monto: e.target.value })} required data-testid="gasto-monto" />
          {isAdmin && (
            <select className={input} value={form.sucursal} onChange={(e) => setForm({ ...form, sucursal: e.target.value })} data-testid="gasto-sucursal">
              {sucs.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          <div>
            <label className="flex items-center justify-center gap-2 rounded-lg border-2 border-dashed border-slate-300 py-4 text-sm font-medium text-[#64748B] cursor-pointer hover:border-[#3B82F6] hover:text-[#3B82F6]" data-testid="gasto-foto-label">
              <Camera className="h-5 w-5" /> {file ? "Cambiar comprobante" : `Foto del comprobante ${isAdmin ? "(opcional)" : ""}`}
              <input type="file" accept="image/*" className="hidden" onChange={pickFile} data-testid="gasto-foto-input" />
            </label>
            {preview && (
              <div className="relative mt-2">
                <img src={preview} alt="comprobante" className="w-full h-40 object-cover rounded-lg border border-slate-200" />
                <button type="button" onClick={() => { setFile(null); setPreview(null); }} className="absolute top-2 right-2 bg-white/90 rounded-full p-1 shadow"><X className="h-4 w-4 text-rose-600" /></button>
              </div>
            )}
          </div>
          <button disabled={saving} className="w-full rounded-lg bg-[#F5A623] text-[#0A1F44] font-bold py-3 text-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="gasto-submit">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} Guardar gasto
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
